module.exports = __webpack_public_path__ + "img/com.electrolux.electroluxinstallerapp.0f627c1e.webp";